// Ayuda rápida del menú de la persona: pasos cortos según la pantalla donde está. Solo texto; no depende de datos ni de permisos.
export type PasoAyuda = { titulo: string; detalle: string };
export type AyudaRapida = { titulo: string; pasos: PasoAyuda[] };

const VENDER: AyudaRapida = {
  titulo: "Vender un boleto",
  pasos: [
    { titulo: "Elige tour, día y horario", detalle: "Hoy y Mañana están a un toque. «Otra fecha» abre el calendario y marca los días con salida." },
    { titulo: "Adultos y menores", detalle: "Con los botones + y −. Para cada menor toca su rango de edad: la tarifa sale sola." },
    { titulo: "Cobra", detalle: "Escribe el WhatsApp del cliente, elige la forma de pago y toca Vender." },
    { titulo: "Subir pasajeros", detalle: "El botón Escanear QR, arriba, lee el boleto y lo sube al camión." },
    { titulo: "Sin señal", detalle: "El aviso de arriba dice si hay señal. Lo que vendas sin señal se guarda en el teléfono y se manda al volver." },
  ],
};
const PANEL: AyudaRapida = {
  titulo: "Moverte por el panel",
  pasos: [
    { titulo: "Buscar", detalle: "Escribe arriba un folio, el nombre o el teléfono de un cliente." },
    { titulo: "Hoy", detalle: "Muestra las salidas del día. Toca una para ver sus boletos y camiones." },
    { titulo: "Ventas y Salidas", detalle: "En Ventas están las reservas y los cobros; en Salidas, los horarios y los camiones." },
    { titulo: "Cambiar de pantalla", detalle: "El menú de tu nombre lleva a Vender, Salidas o Checada según lo que puedas usar." },
  ],
};
const CHOFER: AyudaRapida = {
  titulo: "Tu salida",
  pasos: [
    { titulo: "Elige la salida", detalle: "Toca la salida de hoy para ver quién va en tu camión." },
    { titulo: "Sube a cada pasajero", detalle: "Escanea el QR de su boleto. Si no está pagado, la pantalla te dice cuánto debe." },
    { titulo: "Si vas tarde", detalle: "Avísalo en Hoy, en el panel: el cliente lo ve al momento en su boleto." },
  ],
};
const GENERAL: AyudaRapida = {
  titulo: "Ayuda rápida",
  pasos: [
    { titulo: "Cambiar de pantalla", detalle: "Abre el menú de tu nombre: ahí están las pantallas que puedes usar." },
    { titulo: "Cerrar sesión", detalle: "Siempre está arriba, en naranja, y también al final del menú." },
    { titulo: "¿Algo no funciona?", detalle: "Escríbele a Soporte con lo que viste y en qué pantalla estabas." },
  ],
};

export function ayudaPara(ruta: string): AyudaRapida {
  if (ruta.startsWith("/vender")) return VENDER;
  if (ruta.startsWith("/panel")) return PANEL;
  if (ruta.startsWith("/chofer")) return CHOFER;
  return GENERAL;
}
